module.exports = __webpack_public_path__ + "img/7243644.png";